import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <span className="ms-1">&copy; 2024 EDUNA Platform. All rights reserved.</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://ignisweb.dev" target="_blank" rel="noopener noreferrer">
          IGNIS
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)